class MinicartCount {
    updateCountIndicator (count) {
        const $minicartCount = document.querySelector('[data-minicart-count]');

        console.log(count);
        if (count > 0) {
            console.log($minicartCount);
            $minicartCount.classList.add('minicart--has-items');
        } else {
            $minicartCount.classList.remove('minicart--has-items');
        }

        $minicartCount.setAttribute('data-minicart-count', count);
    }
}

export { MinicartCount };
